//
//
//
//
//
//
 
export default {
    mounted() {
      if(this.$equipment()===null){
         this.$router.push({ path: '/PC' });
      }
      else{
        this.$router.push({ path: '/Mobile' });
      }
    },
    data () {
      return {
      }
    },
};



// WEBPACK FOOTER //
// ./src/components/WholeSaleCenter/CenterPage.vue